import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import QRCode from "qrcode"; // ✅ Generar el QR
import { Dialog, DialogContent } from "@mui/material";
import logoEmpresa from "../../media/logoempresa.png";
import { formatDateTime } from "../../utils/utils";

export const TicketTaller = ({ tareaInfo }) => {
    const [open, setOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [qrDataUrl, setQrDataUrl] = useState(null);

    useEffect(() => {
        if (!tareaInfo || !tareaInfo.token) {
            console.warn("⚠️ No se encontró el token en tareaInfo:", tareaInfo);
            return;
        }

        const generateQR = async () => {
            try {
                const qrUrl = `https://tessamanagement.jcinformatics.es/seguimientoparte/${encodeURIComponent(tareaInfo.token)}`;
                const qrImage = await QRCode.toDataURL(qrUrl, { scale: 4 }); // ✅ Generar QR en alta resolución
                setQrDataUrl(qrImage);
            } catch (error) {
                console.error("Error al generar el QR:", error);
            }
        };

        generateQR();
    }, [tareaInfo]);

    useEffect(() => {
        if (!qrDataUrl) return; // Esperar a que el QR esté listo

        const generatePDF = async () => {
            // 🔹 Crear un contenedor HTML sin altura fija para permitir crecimiento dinámico
            const tempDiv = document.createElement("div");
            tempDiv.style.position = "absolute";
            tempDiv.style.left = "-9999px";
            tempDiv.style.width = "500px";  // Ancho estándar
            tempDiv.style.background = "white";
            tempDiv.style.padding = "2px";
            tempDiv.style.borderRadius = "8px";
            tempDiv.style.boxShadow = "0px 0px 10px rgba(0,0,0,0.1)";
            tempDiv.style.textAlign = "center";

            tempDiv.innerHTML = `
                <img src="${logoEmpresa}" alt="Logo" style="width: 300px; margin-bottom: 10px;" />

                <h1 style="color:rgb(0, 0, 0); margin-bottom: 5px;">N. Ticket: ${tareaInfo.id}</h1>
                <h2>📅 Fecha: ${formatDateTime(tareaInfo.fecha)}</h2>
                <h1>👤 Cliente: ${tareaInfo.nombre_cliente}</h1>
                <h1>📌 Asunto: ${tareaInfo.asunto}</h1>
                <h2 style="margin-top: 18px;">📲 Escanea este QR para seguimiento:</h2>
                <img src="${qrDataUrl}" alt="Código QR" style="width: 250px; height: 250px; margin-bottom: 10px;" />
            `;

            document.body.appendChild(tempDiv);

            // 🔹 Convertir el HTML dinámico a imagen
            const canvas = await html2canvas(tempDiv, { scale: 3 }); // ✅ Aumentar la resolución para más calidad
            document.body.removeChild(tempDiv);

            // 🔹 Calcular altura dinámica del PDF
            const imgWidth = 210; // Ancho estándar
            const imgHeight = (canvas.height * imgWidth) / canvas.width; // Mantener proporción

            // 🔹 Generar el PDF con la imagen capturada
            const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]); // Altura ajustada dinámicamente
            pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, imgWidth, imgHeight);

            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfUrl(pdfUrl);
            setOpen(true);
        };

        generatePDF();
    }, [qrDataUrl]); // Genera el PDF cuando el QR esté listo

    return (
        <Dialog open={open} onClose={() => { setPdfUrl(null); setOpen(false); }} maxWidth="md" fullWidth>
            <DialogContent>
                {pdfUrl && (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa PDF" />
                )}
            </DialogContent>
        </Dialog>
    );
};
